"use strict";
// Copyright (C) 2017-2025 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Item_less_1 = __importDefault(require("./Item.less"));
var ItemPlaceholder = function () {
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(Item_less_1.default['item'], Item_less_1.default['placeholder']) },
        react_1.default.createElement("div", { className: Item_less_1.default['heading'] },
            react_1.default.createElement("div", { className: Item_less_1.default['text'] })),
        react_1.default.createElement("div", { className: Item_less_1.default['body'] },
            react_1.default.createElement("div", { className: Item_less_1.default['video'] },
                react_1.default.createElement("div", { className: Item_less_1.default['artwork'] }),
                react_1.default.createElement("div", { className: Item_less_1.default['name'] })))));
};
exports.default = ItemPlaceholder;
